<template>
    <svg
        width="13"
        height="13"
        viewBox="0 0 13 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="e-remove">
            <path
                id="Path"
                d="M10.2104 1.20437C10.6912 0.723544 11.4708 0.723544 11.9516 1.20437C12.3888 1.64148 12.4285 2.32549
                    12.0709 2.80749L11.9516 2.94558L2.10183 12.7954C1.62101 13.2762 0.841441 13.2762 0.360618
                    12.7954C-0.0764949 12.3583 -0.116232 11.6743 0.241406 11.1923L0.360618 11.0542L10.2104 1.20437Z"
                fill="#8EC63E"
            />
            <path
                id="Path_2"
                d="M0.360617 1.20437C0.797729 0.767255 1.48174 0.727518 1.96374 1.08516L2.10183 1.20437L11.9516
                    11.0542C12.4325 11.535 12.4325 12.3146 11.9516 12.7954C11.5145 13.2325 10.8305 13.2722
                    10.3485 12.9146L10.2104 12.7954L0.360617 2.94558C-0.120206 2.46476 -0.120206 1.68519
                    0.360617 1.20437Z"
                fill="#8EC63E"
            />
        </g>
    </svg>
</template>

<script>
export default {
  name: 'IconCross',
};
</script>
